



















import CreditCard from '@/components/Reusable/CreditCard.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'PaymentsMethods',
  components: { CreditCard, },
  props: {
    paymentMethod: {
      required: true,
      type: String,
    },
    text: {
      required: false,
      type: Boolean,
      default: false,
    },
    cardLastDigits: {
      required: false,
      type: String,
    },
    cardNetwork: {
      required: false,
      type: String,
    },
  },
  computed: {
    isCreditCard(): boolean {
      return this.paymentMethod === 'credit_card';
    },
    isCash(): boolean {
      return this.paymentMethod === 'cash';
    },
    isBoth(): boolean {
      return this.paymentMethod === 'both';
    },
  },
});
